export enum Scelta {
    accetta = 'accetta',
    rifiuta = 'rifiuta'
}